const translations = {
    'app.hexMapLabel': 'Hex map',
    'modal.close': 'X',
};

export default translations;
